/**
 * Lista de tipos de testes disponíveis.
 *
 * Testes de Anamnese:
 * - 2: Teste de Anamnese
 *
 * Testes Olfativos:
 * - 1: Teste de Olfato de Identificação
 * - 3: Teste de Olfato de Discriminação
 * - 4: Teste de Olfato de Identificação Infantil Síndrome de Down
 * - 5: Teste de Olfato de Perceptição
 * - 6: Teste de Olfato de Identificação Pediátrico
 *
 * Testes Cognitivos e Audiometria:
 * - 7: Teste Cognitivo
 * - 8: Teste de Audiometria
 *
 * Esta função retorna uma lista de IDs de acordo com o tipo de teste, passando o parâmetro `type` como string.
 * Exemplo: 'olfactory' irá retornar os IDs dos testes olfativos.
 *
 * @param type Tipo de teste: 'olfactory', 'cognitive', 'audiometry', 'anamnese'
 * @returns Lista de IDs dos testes correspondentes ao tipo informado
 */

export type TestType = 'olfactory' | 'cognitive' | 'audiometry' | 'anamnese' | 'olfactory-identifications' ;
export function getTestIdsByCategory(
  type?: TestType,
): string[] {
  switch (type) {
    case 'olfactory':
      return ['1', '4', '3', '5', '6'];
    case 'cognitive':
      return ['7'];
    case 'audiometry':
      return ['8'];
    case 'anamnese':
      return ['2'];
    case 'olfactory-identifications':
      return ['1', '4', '6'];
    default:
      return ['1'];
  }
}

/**
 * Recupera o identificador numérico para um tipo específico de teste.
 *
 * @param type - O tipo de teste a ser identificado. Pode ser um dos seguintes:
 *   'olfactory-identification' - Teste de identificação olfativa
 *   'olfactory-discrimination' - Teste de discriminação olfativa
 *   'olfactory-child-syndrome-down' - Teste olfativo para crianças com síndrome de Down
 *   'olfactory-identification-perceptive' - Teste de identificação olfativa perceptiva
 *   'olfactory-identification-pediatric' - Teste de identificação olfativa pediátrico
 *   'cognitive' - Teste cognitivo
 *   'audiometry' - Teste de audiometria
 *   'anamnese' - Teste de anamnese
 *
 * @returns O identificador numérico do tipo de teste.
 *          Retorna uma string vazia se o tipo de teste não for reconhecido.
 */
export function getTestTypeId(
  type:
    | 'olfactory-identification'
    | 'olfactory-discrimination'
    | 'olfactory-child-syndrome-down'
    | 'olfactory-identification-perceptive'
    | 'olfactory-identification-pediatric'
    | 'cognitive'
    | 'audiometry'
    | 'anamnese',
): string {
  switch (type) {
    case 'olfactory-identification':
      return '1';
    case 'anamnese':
      return '2';
    case 'olfactory-discrimination':
      return '3';
    case 'olfactory-child-syndrome-down':
      return '4';
    case 'olfactory-identification-perceptive':
      return '5';
    case 'olfactory-identification-pediatric':
      return '6';
    case 'cognitive':
      return '7';
    case 'audiometry':
      return '8';
    default:
      return '';
  }
}
